export default __webpack_public_path__ + "static/Brico_Legal Notice v1.0-6d7c5ddbd45bcd8201660cccac5596b6.pdf";